const swiper = new Swiper('.swiper-container', {
  loop: true,
	watchSlidesProgress: true,
  autoplay: {
    delay: 5000,
		disableOnInteraction: false
  },
  navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	pagination: {
		el: '.swiper-pagination',
		clickable: true
	},
  on: {
    init() {
      this.el.addEventListener("mouseenter", () => {
        this.autoplay.stop();
      });

      this.el.addEventListener("mouseleave", () => {
        this.autoplay.start();
      });
    },
  }, 
});











document.querySelectorAll('.accordion-title').forEach((item) => {
    item.addEventListener('click', () => {
        const content = item.nextElementSibling;
        const icon = item.querySelector('.accordion-icon');
        
        if (content.classList.contains('active')) {
            content.classList.remove('active');
            icon.style.transform = 'rotate(0deg)';
        } else {
            document.querySelectorAll('.accordion-content').forEach((content) => {
                content.classList.remove('active');
            });
            document.querySelectorAll('.accordion-icon').forEach((icon) => {
                icon.style.transform = 'rotate(0deg)';
            });
            content.classList.add('active');
            icon.style.transform = 'rotate(180deg)';
        }
    });
});
